const selectCamera = state => state.camera;

export const selectCameraStatus = state => selectCamera(state).isCameraOpen;
